import React from "react";
import { GetCorServicei,INSCorServicePostTest } from '../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

require('../_css/PopUpARInvDebt.css');

export default class PopUpOther extends React.Component {
    state = {
        type: this.props.type,
        col: [],
        rows: [],
        valueRetuen: "",
        Htext: "",
        SHtype: 3,
        casschkbox: "far fa-square",
        casschkboxs: false,
        ckbox_length: 0,
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
  

    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {
        var dataArray = [];
        this.setState({ sh_Deposit: true });

 
        var Url = "CSARPAYBILL/Searchpaybillsub?DOCNO=" + this.props.P_DOCNO;
        GetCorServicei(Url, "").then(res => {
        // var Url = "http://Localhost:8080/Searchpaybillsub?DOCNO=" + this.props.P_DOCNO;
        // INSCorServicePostTest(Url, "").then(res => {
            if (res.data) {
                // if(res.data.length>=1){
                for (var i = 0; i < res.data.length; i++) {
                    dataArray[i] = {
                        number: i + 1,
                        DOCNO: res.data[i].DOCNO,
                        DOCDATE: this.GetformatTimestamp(res.data[i].DOCDATE),
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFDUEDATE: this.GetformatTimestamp(res.data[i].REFDUEDATE),
                        REFTAXNO: res.data[i].REFTAXNO,
                        REFAMOUNT: res.data[i].REFAMOUNT,
                        PAYAMOUNT: res.data[i].PAYAMOUNT,
                        TYPE: res.data[i].TYPE, 
                        CLOSEFLAG: res.data[i].CLOSEFLAG,
                        REFDOCTYPE: res.data[i].REFDOCTYPE,
                        SB: "0"
                    }
                }
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                // dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
            //}        
        });
        this.setState({ col: dataArray, Htext: "เลือกรายการย่อย" });
    }

    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i class="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i class="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i class="">  </i></span>;

        }
        return (<div>{btnShow}</div>)
    }
    Update_Status = (Row, Status) => {
        var dataArray
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });

            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                dataArray = this.state.rows;
                for (var i1 = 0; i1 < this.state.rows.length && this.state.rows[i1].DOCNO; i1++) {
                    dataArray[i1].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            var sb_length = 0;
            for (var i2 = 0; i2 < this.state.rows.length && this.state.rows[i2].DOCNO; i2++) {
                if (this.state.rows[i2].SB === 1) { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }
 
    onSelectRow = (data, col, id) => {
        this.setState({ valueRetuen: data.code });
        var reData = [];
        var dataArray

        if (col > 1) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            
            dataArray = this.state.rows;
            console.log(dataArray);
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            //------------------------ 
            var sb_length = 0;
            var j = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === "1") {
                    sb_length = sb_length + 1;
                    reData[j] = {
                        DOCNO: this.state.rows[i].DOCNO,
                        REFTAXNO: this.state.rows[i].REFTAXNO,
                        DOCDATE: this.state.rows[i].DOCDATE,
                        CREDITCODE: this.state.rows[i].CREDITCODE,
                        REFDUEDATE: this.state.rows[i].REFDUEDATE,
                        TRANSNAME: this.state.rows[i].TRANSNAME,
                        department: this.state.rows[i].department,
                        PAYAMOUNT: this.state.rows[i].PAYAMOUNT,
                        REMARK: this.state.rows[i].REMARK,
                        TYPE: this.state.rows[i].TYPE,
                        REFDOCTYPE: this.state.rows[i].REFDOCTYPE
                    }
                    j = j + 1;
                }
            }
            if (reData.length === sb_length) {
                this.props.Get_PopUpOther5(reData);
            }
        }
    }
    onSubmit = () => {
        var reData = [];
            var sb_length = 0;
            var j = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === "1") {
                    sb_length = sb_length + 1;
                    reData[j] = {
                        DOCNO: this.state.rows[i].DOCNO,
                        REFTAXNO: this.state.rows[i].REFTAXNO,
                        DOCDATE: this.state.rows[i].DOCDATE,
                        CREDITCODE: this.state.rows[i].CREDITCODE,
                        REFDUEDATE: this.state.rows[i].REFDUEDATE,
                        TRANSNAME: this.state.rows[i].TRANSNAME,
                        department: this.state.rows[i].department,
                        PAYAMOUNT: this.state.rows[i].PAYAMOUNT,
                        REMARK: this.state.rows[i].REMARK,
                        TYPE: this.state.rows[i].TYPE,
                        REFDOCTYPE: this.state.rows[i].REFDOCTYPE
                    }
                    j = j + 1;
                }
            }
            if (reData.length === sb_length) {
                this.props.Get_PopUpOther5(reData);
            }
    }
    render() {
        return (
            <div className='popup' style={{ 'z-index': '100' }} >
                <div className='popup_inner'>
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1"><i class="fas fa-at" > {this.state.Htext} </i></div>
                        <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div class="panel-body divTable" align="right">
                        {/* {this.state.sh_Deposit === true ?
                            <div class=" form-group input-group col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                <input id="id1" type="text" class="form-control" ref="Search" onKeyPress={this.Get_Data.bind(null)} onBlur={this.Get_Data.bind(null, "ARInvDebt")} />
                                <span id="iconsearch" class="input-group-addon icon"><i class="fas fa-search"></i></span>
                            </div>
                            : null
                        } */}
                        <div  >
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="580"
                                hover condensed search={true} >
                                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="40" dataField='number' isKey><div onClick={this.props.closePopup}><i style={{ fontSize: '28px' }} class="fas fa-reply-all"  ></i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="40" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i style={{ fontSize: '20px' }} class={this.state.casschkbox}> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="190" dataField='DOCNO'> เลขที่ใบวางบิล </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='DOCDATE' > วันที่วางบิล </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="190" dataField='REFDOCNO' > เอกสารขาย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='REFDUEDATE' dataAlign="left" > ครบกำหนด </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="190" dataField='REFTAXNO' dataAlign="left"> ใบกำกับ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='REFAMOUNT' dataAlign="left"> ยอดยกมา </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='PAYAMOUNT' dataAlign="left"> ยอดวางบิล </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='TYPE' dataAlign="right"> ประเภท </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='CLOSEFLAG' dataAlign="right"> CLOSEFLAG </TableHeaderColumn>
                                <TableHeaderColumn dataField='REMARK' hidden>  </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        <button class="PUSDbtn" onClick={this.onSubmit}>
                            <i class="fas fa-check"> ตกลง </i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}